import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../globals';
import {CommonModule} from '@angular/common';
import {FormService} from '../services/FormService';
import {Checkbox} from 'primeng/checkbox';
import {Card} from 'primeng/card';
import {Message} from 'primeng/message';
import {FileUpload} from 'primeng/fileupload';
import {Divider} from 'primeng/divider';
import {environment} from '../../environments/environment';
import {Subscription} from 'rxjs';

declare var Yii: IYii;

@Component({
  selector: 'ng-form-hybryd-pdf',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox,
    Card,
    Message,
    FileUpload,
    Divider
  ],
  template: `
    @if (fsvc.formId && !fsvc.form.isHTMLForm) {
      <div class="form-row">
        <label>
          {{ Yii.t('be_forms', 'Apply a specific view to pdf file') }}
        </label>
        <div>
          <p-checkbox [(ngModel)]="fsvc.form_json.applySpecificPdf" binary="true"></p-checkbox>
        </div>
      </div>
    }

    @if (fsvc.formId && fsvc.form.applySpecificPdf && !fsvc.form.isHTMLForm) {
      <p-card>
        <div class="form-row">
          <label></label>
          <div class="flex-col gap-8px">
            <p-message severity="info">
              {{ Yii.t('be_forms', 'Both pdf template and coordinates.csv should be uploaded') }}
            </p-message>
            @if (fsvc.form.apply_specific_pdf) {
              <p-message severity="success">
                {{ Yii.t('be_forms', 'Uploaded Pdf template will be applied to the form pdf view') }}
              </p-message>
            } @else {
              <p-message severity="error">
                {{ Yii.t('be_forms', 'Simple pdf view will be generated ') }}
              </p-message>
            }
          </div>
        </div>
        <div class="form-row flex-align-center">
          <label>
            {{ Yii.t('be_forms', 'Pdf template') }}
          </label>
          <div class="flex-row gap-16px flex-align-center">
            <p-fileupload
              #uploaderPDF
              [showUploadButton]="false"
              [showCancelButton]="false"
              mode="basic"
              accept="application/pdf"
              (onSelect)="fsvc.hybrid.SelectPDFFile($event)"
            />
            <span class="help-inline error" id="pdf-template_" style="display: none"></span>

            @if (fsvc.form.pdf_template_file && !fsvc.hybrid.selectedPDFFile) {
              <p-divider layout="vertical" />
              <strong>Current file:</strong>
              <a
                [href]="api+fsvc.form.pdf_template_file+'?token='+token"
                target="_blank"
                class="p-button-link">{{ pdf_template_file }}</a>
            }
          </div>
        </div>
        <div class="form-row flex-align-center">
          <label>
            {{ Yii.t('be_forms', 'Coordinates') }}
          </label>
          <div class="flex-row gap-16px flex-align-center">
            <p-fileupload
              #uploaderCSV
              [showUploadButton]="false"
              [showCancelButton]="false"
              mode="basic"
              accept=".csv"
              (onSelect)="fsvc.hybrid.SelectCSVFile($event)"
            />
            @if (fsvc.form.pdf_template_coordinates_file && !fsvc.hybrid.selectedCSVFile) {
              <p-divider layout="vertical" />
              <strong>Current file:</strong>
              <a
                [href]="api+fsvc.form.pdf_template_coordinates_file+'?token='+token"
                class="p-button-link">{{ pdf_template_coordinates_file }}</a>
            }
          </div>
        </div>
        <div class="form-row">
          <label></label>
          <div>
            <a href="{{api}}/api/forms/getCsvTemplateSample?id={{fsvc.form.form_id}}&token={{token}}"
               class="p-button-link"
               style="text-decoration: none"
               target="_blank">
              {{ Yii.t('be_forms', 'You can download a CSV template file by clicking this link') }}
              <i class="fa fa-download"></i>
            </a>
          </div>
        </div>
        <div class="form-row">
          <div>
            @if (fsvc.form.pdf_result === -1) {
              <p-message severity="error">
                {{ Yii.t('be_forms', 'Pdf file has not been uploaded') }}
              </p-message>
            }
            @if (fsvc.form.pdf_result === 1) {
              <p-message severity="success">
                {{ Yii.t('be_forms', 'Pdf file has been uploaded successfully') }}
              </p-message>
            }
            @if (fsvc.form.coordinates_result === -1) {
              <p-message severity="error">
                {{ Yii.t('be_forms', 'Coordinate file has not been uploaded') }}
              </p-message>
            }
            @if (fsvc.form.coordinates_result === 1) {
              <p-message severity="success">
                {{ Yii.t('be_forms', 'Coordinate file has been uploaded successfully') }}
              </p-message>
            }
          </div>
        </div>
      </p-card>
    }
  `
})
export class FormHybrydPDFComponent implements OnInit, OnDestroy {
  subs: Subscription[] = [];
  Yii = Yii;
  api = environment.api
  token = localStorage.getItem('apiToken')
  public pdf_template_file: string = '';
  public pdf_template_coordinates_file: string = '';

  @ViewChild('uploaderPDF') uploaderPDF: FileUpload;
  @ViewChild('uploaderCSV') uploaderCSV: FileUpload;

  constructor(public fsvc: FormService) {
  }

  ngOnInit(): void {
    let u = this.fsvc.form.pdf_template_file.split('/')
    if(u.length > 0) {
      this.pdf_template_file = u.pop();
    }
    u = this.fsvc.form.pdf_template_coordinates_file.split('/')
    if(u.length > 0) {
      this.pdf_template_coordinates_file = u.pop();
    }
    this.subs.push(this.fsvc.hybrid.onUploadSuccess.subscribe(() => {
      if(this.uploaderPDF) {
        this.uploaderPDF.clear();
      }
      if(this.uploaderCSV) {
        this.uploaderCSV.clear();
      }
    }));
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
